import { Link } from "@tanstack/react-router";
import { BookOpen, ArrowRight } from "lucide-react";
import type { ArticleMeta } from "@/lib/related";

type Props = {
  items: ArticleMeta[];
  heading?: string;
};

export function RelatedArticles({ items, heading = "Artigos relacionados" }: Props) {
  if (!items.length) return null;
  return (
    <aside aria-labelledby="related-articles-heading" className="mt-4">
      <h2
        id="related-articles-heading"
        className="font-display text-2xl md:text-3xl font-bold mb-5 flex items-center gap-2"
      >
        <BookOpen className="h-6 w-6 text-primary" /> {heading}
      </h2>
      <ul className="grid gap-3 sm:grid-cols-2">
        {items.map((a) => (
          <li key={a.slug}>
            <Link
              to="/artigos/$slug"
              params={{ slug: a.slug }}
              className="group flex items-start justify-between gap-3 rounded-2xl border border-border bg-card p-4 shadow-soft hover:border-primary/40 hover:shadow-md transition"
            >
              <div className="min-w-0">
                <div className="font-display font-bold text-base leading-tight">{a.titulo}</div>
                <p className="mt-1 text-sm text-muted-foreground line-clamp-2">{a.resumo}</p>
              </div>
              <ArrowRight className="h-4 w-4 mt-1 text-muted-foreground group-hover:text-primary group-hover:translate-x-0.5 transition shrink-0" />
            </Link>
          </li>
        ))}
      </ul>
      <div className="mt-5">
        <Link
          to="/artigos"
          className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:underline"
        >
          Ver todos os artigos <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </aside>
  );
}
